<style lang="scss">
	.back-table{
		margin: 0px 0 5px;
		padding: 15px;
		background: #fbfbfb;
		h4 {
			color: #101010;
			display: table;
			b{
				display: table-cell;
				width: 100px;
				text-align: center;
				padding: 5px 0;
			}
			b.way{
				width: 150px;
				text-align: center;
			}
			b.percent{
				width: 200px;
			}
		}
		ul li{
			.cell{
				display: inline-block;
				text-align: center;
				width: 100px;
				.el-input{
					width: 70px;
				}
			}
			.cell.way{
				width: 150px;
				.el-select .el-input{
					width: 120px;
				}
			}
			.cell.btn{
				width: 60px;
				text-align: left;
			}
			.cell.percent{
				width: 200px;
				.input-number140{
					width: 60px;
					.el-input{
						width: auto;
					}
				}
			}
			.el-form-item{
				display: inline-block;
			}
			/*.input-number{*/
			/*width: 100px;*/
			/*.el-input{*/
			/*width: auto;*/
			/*}*/
			/*}*/

		}
		ul li:last-of-type{
			margin-bottom: 0px;
		}
		ul li .cell>i{
			margin-left: 10px;
			cursor: pointer;
		}
		label{
			margin: 0 10px;
		}
		/*.el-select {*/
		/*margin: 0 0px 0 30px;*/
		/*}*/
	}
</style>
<template>
	<div class="passBack">
		<div class="contentbox">
			<div class="notetop nobottom">
				<el-form :inline="true" ref="formInline" :model="formInline" size="small" class="demo-form-inline">
					<!--<el-form-item label="微博小程序：" style="margin-right: 30px;">-->
					<!--<el-select v-model="formInline.CDId" filterable clearable placeholder="请选择小程序" style="width: 200px;">-->
					<!--<el-option-->
					<!--v-for="item in appOptions"-->
					<!--:key="item.CDId"-->
					<!--:label="item.appName"-->
					<!--:value="item.CDId">-->
					<!--</el-option>-->
					<!--</el-select>-->
					<!--</el-form-item>-->
					<el-form-item label="方案ID" prop="id">
						<el-input type="number" v-model="formInline.id" placeholder="请输入方案ID" clearable  @keyup.enter.native="search" @clear="search" style="width: 200px;"></el-input>
					</el-form-item>
					<el-form-item label="方案名称" prop="strategyName">
						<el-input v-model="formInline.strategyName" placeholder="请输入方案名称" clearable  @keyup.enter.native="search" @clear="search" style="width: 200px;"></el-input>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" icon="el-icon-search" @click="search" style="margin-left: 20px;">查询</el-button>
					</el-form-item>
					<el-form-item>
						<el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
					</el-form-item>
					<br/>
					<el-form-item>
						<el-button type="success" v-has="menuPage == 'agent' ? 'agentReturnConfig:add' : 'returnConfig:add'" icon="el-icon-circle-plus-outline" @click="addData">添加</el-button>
					</el-form-item>
				</el-form>
			</div>
			<div class="tableTh">
				<el-table
						:data="tableData.result"
						border stripe
						style="width: 100%" class="tableStyle">
					<el-table-column
							type="index" label="序号" width="100">
					</el-table-column>
					<el-table-column
							prop="id"
							label="方案ID"
							width="200">
					</el-table-column>
					<el-table-column
							prop="strategyName"
							label="方案名称"
							width="200">
					</el-table-column>
					<el-table-column
							label="回传付费金额"
							width="200">
						<template slot-scope="scope">
							<span v-if="scope.row.callBackAmount == 1">是</span>
							<span v-if="scope.row.callBackAmount == 0">否</span>
						</template>
					</el-table-column>
					<el-table-column label="回传配置" width="300">
						<template slot-scope="scope">
							<span v-if="scope.row.returnCaliber == 0">全部回传配置</span>
							<span v-if="scope.row.returnCaliber == 1">卡回传配置</span>
						</template>
					</el-table-column>
					<el-table-column label="回传规则">
						<template slot-scope="scope">
							<div v-if="scope.row.returnCaliber == 0">
								<span v-if="scope.row.returnCaliberParam == 1">回传用户当天自然日所有充值</span>
								<span v-if="scope.row.returnCaliberParam == 2">回传用户当天自然日的首充</span>
							</div>
							<div class="td-info" v-if="scope.row.returnCaliber == 1">
								<p>回传维度：按计划回传</p>
								<p>回传保护数：{{scope.row.returnProtection}}</p>
								<p>回传规则：</p>
								<ul>
									<li v-for="(item, index) in scope.row.partReturnData" :key="index">
										<span>{{item.minTopUpAmount}}-{{item.maxTopUpAmount}}：</span>
										<span v-if="item.returnWay == 2">全部回传</span>
										<span v-if="item.returnWay == 0">全部不回传</span>
										<span v-if="item.returnWay == 1">
                                            传{{item.returnPercent}}漏{{item.returnLeach}}
                                        </span>
									</li>
								</ul>
							</div>
						</template>
					</el-table-column>
					<el-table-column
							prop="deleted"
							label="操作" align="center">
						<template slot-scope="scope" class="ddd">
							<el-button type="primary" v-has="menuPage == 'agent' ? 'agentReturnConfig:update' : 'returnConfig:update'" icon="el-icon-edit" size="mini" @click="handleEdit(scope.row.id)">编辑</el-button>
						</template>
					</el-table-column>
				</el-table>
				<div class="foot-table" style="text-align:center;">
					<el-pagination
							@current-change="handleCurrentChange"
							@size-change="handleSizeChange"
							:page-sizes="[20, 50, 100, 200, 500]"
							:page-size="tableData.pageSize"
							background
							:current-page="currentPage"
							layout="sizes, prev, pager, next, jumper, ->, total"
							:total="tableData.totalNum">
					</el-pagination>
				</div>
			</div>
		</div>
		<!--添加-->
		<el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible" width="750px">
			<el-form :rules="rules" ref="ruleForm" :model="ruleForm" size="small" class="input350" label-width="140px" >
				<!--<el-form-item label="微博小程序：">-->
				<!--<span>{{appName}}</span>-->
				<!--</el-form-item>-->
				<el-form-item label="方案名称：" prop="strategyName">
					<el-input v-model="ruleForm.strategyName" min="1" placeholder="仅做标记，无实际作用" clearable style="width: 400px;"></el-input>
				</el-form-item>
				<el-form-item label="回传方式：" prop="returnEvent">
					<el-select v-model="ruleForm.returnEvent" filterable clearable placeholder="请选择回传事件" style="width: 400px;">
						<el-option
								v-for="item in returnEventOptions"
								:key="item.value"
								:label="item.label"
								:value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="回传付费金额：">
					<el-radio-group v-model="ruleForm.callBackAmount">
						<el-radio :label="0">是</el-radio>
						<el-radio :label="1">否</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="回传类型：" prop="type">
					<el-select v-model="ruleForm.type" filterable clearable placeholder="请选择回传类型" style="width: 400px;">
						<el-option
								v-for="item in typeOptions"
								:key="item.value"
								:label="item.label"
								:value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<h4 style="margin: 20px -20px 0; padding: 15px 0 15px 50px; border-top: 1px solid #BBBBBB; color: #101010" >回传配置</h4>
				<el-form-item style="margin-left: -80px;">
					<el-radio-group v-model="ruleForm.returnCaliber">
						<el-radio :label="0">全部回传配置</el-radio>
						<el-radio :label="1">卡回传配置</el-radio>
					</el-radio-group>
				</el-form-item>
				<div v-if="ruleForm.returnCaliber == 0">
					<el-form-item label="回传条件：">
						<el-radio-group v-model="ruleForm.returnCaliberParam">
							<el-radio :label="1" style="display: block; margin: 8px 0 20px;">回传用户当天自然日所有充值</el-radio>
							<el-radio :label="2">回传用户当天自然日的首充</el-radio>
						</el-radio-group>
					</el-form-item>
				</div>
				<div v-if="ruleForm.returnCaliber == 1">
					<el-form-item label="回传时间：">
						<el-select v-model="ruleForm.timeDimension" style="width: 400px;">
							<el-option
									v-for="item in returnTimeOptions"
									:key="item.value"
									:label="item.label"
									:value="item.value">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="回传维度：" prop="returnDimension">
						<el-select v-model="ruleForm.returnDimension" clearable placeholder="请选择回传维度" style="width: 400px;" :disabled="dialogTitle == '编辑' ? true : false">
							<el-option
									v-for="item in returnWdOptions"
									:key="item.value"
									:label="item.label"
									:value="item.value">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="回传保护数：" prop="returnProtection">
						<el-input type="number" v-model="ruleForm.returnProtection" min="0" placeholder="输入几，前X笔不卡回传" clearable  style="width: 400px;"></el-input>
					</el-form-item>
					<el-form-item label="回传规则：">
						<div class="back-table" style="margin: 40px 20px 0 -90px;">
							<h4>
								<b>最小额（&gt;）</b>
								<b>最大额（&lt;）</b>
								<b class="way">回传方式</b>
								<b class="percent">回传比例</b>
							</h4>
							<ul>
								<li v-for="(item, index) in ruleForm.partReturnData" :key="index">
									<div class="cell">
										<el-input v-if="index == 0" type="number" v-model="item.minTopUpAmount" placeholder=""></el-input>
										<el-input v-else type="number"  v-model="item.minTopUpAmount" :disabled="true" placeholder=""></el-input>
										<label style="position: relative; left: 10px;">-</label>
									</div>
									<div class="cell">
										<el-form-item :prop="'partReturnData.' + index + '.maxTopUpAmount'" :rules="rules.maxTopUpAmount" :key="'partReturnData.' + index + '.maxTopUpAmount'">
											<el-input type="number" v-model="item.maxTopUpAmount" @input="inputMax(index, item.maxTopUpAmount)" @change="changeMax(index, item.maxTopUpAmount)" placeholder=""></el-input>
										</el-form-item>
									</div>
									<div class="cell way">
										<el-form-item>
											<el-select v-model="item.returnWay" filterable clearable placeholder="请选择小程序" style="width: 120px;">
												<el-option
														v-for="item in returnWayOptions"
														:key="item.value"
														:label="item.label"
														:value="item.value">
												</el-option>
											</el-select>
										</el-form-item>
									</div>
									<div class="cell percent">
										<template v-if="item.returnWay == 1">
											<span style="margin-right: 5px;">传</span>
											<el-form-item :prop="'partReturnData.' + index + '.returnPercent'" :rules="rules.returnPercent" :key="'partReturnData.' + index + '.returnPercent'">
												<el-input type="number" class="input-number140"  v-model="item.returnPercent" min="1"></el-input>
											</el-form-item>
											<span style="margin: 0 8px;">漏</span>
											<el-form-item :prop="'partReturnData.' + index + '.returnLeach'" :rules="rules.returnLeach" :key="'partReturnData.' + index + '.returnLeach'">
												<el-input type="number" class="input-number140" v-model="item.returnLeach" min="0"></el-input>
											</el-form-item>
										</template>
										<template v-if="item.returnWay == 0">
											<span style="font-size: 13px;">全部不回传</span>
										</template>
										<template v-if="item.returnWay == 2">
											<span style="font-size: 13px;">全部回传</span>
										</template>
									</div>
									<div class="cell btn">
										<!--</template>-->
										<i class="el-icon-circle-plus-outline" @click="addBack(item.maxTopUpAmount, index)"></i>
										<i class="el-icon-remove-outline" v-if="ruleForm.partReturnData.length > 1" @click="delBack(index)"></i>
									</div>
								</li>
							</ul>
							<div class="danger-text">重点：未在规则内的额度全部不回传</div>
						</div>
					</el-form-item>
				</div>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogFormVisible = false">取 消</el-button>
				<el-button type="primary" @click="editDialogSureBtn('ruleForm')">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
    import { list, details, add } from "@/api/wb/agentmenu/return";
    export default {
        name: 'WbReturn',
		props:['menuPage'],
        data () {
            // 这里可以监听添加内
            var validateLeach = (rule, value, callback) => {
                if (value <0) {
                    return callback(new Error('输入的漏传数不能小于0'));
                } else {
                    callback();
                }
            };
            var validatePercent = (rule, value, callback) => {
                if (value <= 0) {
                    return callback(new Error('输入的回传数必须大于0'));
                } else {
                    callback();
                }
            };
            return {
                formInline: {
                    id: '',
                    strategyName: ''
                },
                tableData: {
                    pageSize: 20,
                    pageNo: 1,
                    totalPage: 1,
                    totalNum: 1,
                    result: []
                },
                currentPage: 1,
                appOptions: [
                ],
                returnEventOptions: [
                    {
                        value: '1',
                        label: '付费'
                    },
                    // {
                    //     value: 2,
                    //     label: '注册'
                    // },
                    // {
                    //     value: 3,
                    //     label: '关键行为'
                    // }
                ],
                typeOptions: [
                    // {
                    //     value: 1,
                    //     label: '免费回传'
                    // },
                    {
                        value: 2,
                        label: '付费回传'
                    },
                    {
                        value: 3,
                        label: '表单回传'
                    }
                ],
                returnWayOptions: [
                    {
                        value: 0,
                        label: '全部不回传'
                    },
                    {
                        value: 1,
                        label: '部分回传'
                    },
                    {
                        value: 2,
                        label: '全部回传'
                    }
                ],
                returnWd: 1,
                returnTimeOptions: [
                    {
                        value: 1,
                        label: '当天自然日'
                    }
                ],
                returnWdOptions: [
                    {
                        value: 1,
                        label: '按计划回传'
                    },
                    {
                        value: 2,
                        label: '按链接回传'
                    }
                ],
                dialogFormVisible: false,
                dialogTitle: '添加',
                appName: '',
                ruleForm: {
                    id: '',
                    strategyName: '',
                    returnEvent: '1',
					type: 2,
                    callBackAmount: 0,
                    returnCaliber: 0,
                    returnCaliberParam: 1,
                    returnProtection: null,
                    timeDimension: 1,
                    returnDimension: 1,
                    partReturnData: [
                        {
                            minTopUpAmount: 0,
                            maxTopUpAmount: null,
                            returnWay: 0,
                            returnLeach: null,
                            returnPercent: null
                        }
                    ],
                },
                rules: {
                    strategyName: [{required: true, message: '请输入方案名称', trigger: 'blur'}],
                    returnEvent: [
                        { required: true, message: '请选择回传方式', trigger: 'change' }
                    ],
                    type: [
                        { required: true, message: '请选择回传类型', trigger: 'change' }
                    ],
                    returnDimension: [
                        { required: true, message: '请选择回传维度', trigger: 'change' }
                    ],
                    maxTopUpAmount: [{required: true, message: '最大金额', trigger: 'blur'}],
                    returnLeach: [
                        {required: true, message: '漏传数', trigger: 'blur'},
                        { validator: validateLeach, trigger: 'blur' }
                    ],
                    returnPercent: [
                        {required: true, message: '回传数', trigger: 'blur'},
                        { validator: validatePercent, trigger: 'blur' }
                    ],
                    returnProtection: [
                        {required: true, message: '请输入回传保护数', trigger: 'blur'}
                    ]
                },
            }
        },
        computed: {

        },
        mounted: function () {
            // this.getAppList()
            this.getTableData()
        },
        methods: {
            // 查询
            search () {
                this.getTableData ()
            },
            resetQuery () {
                this.$refs['formInline'].resetFields()
                this.getTableData()
            },
            handleCurrentChange(value) {
                this.currentPage = value
                this.getTableData()
            },
            handleSizeChange (val) {
                this.tableData.pageSize = val
                this.currentPage = 1
                this.getTableData()
            },
            // 添加表格
            addData()  {
                this.dialogTitle = '添加'
                this.ruleForm = {
                    id: '',
                    strategyName: '',
                    returnEvent: '1',
					type: 2,
                    callBackAmount: 0,
                    returnCaliber: 0,
                    returnCaliberParam: 1,
                    returnProtection: null,
                    timeDimension: 1,
                    returnDimension: 1,
                    partReturnData: [
                        {
                            minTopUpAmount: 0,
                            maxTopUpAmount: null,
                            returnWay: 0,
                            returnLeach: null,
                            returnPercent: null
                        }
                    ]
                }
                if (this.$refs['ruleForm'] !== undefined) {
                    this.$refs['ruleForm'].clearValidate()
                }
                this.dialogFormVisible = true
            },
            // 编辑
            handleEdit (id) {
                // this.getEditData(id, index)
                this.dialogTitle = '编辑'
                this.dialogFormVisible = true
                if (this.$refs['ruleForm'] !== undefined) {
                    this.$refs['ruleForm'].clearValidate()
                }
                this.getDetials(id)
            },
            getDetials (id) {
                details({
                    id: id,
                }).then((response) => {
                    console.log(response)
                    if (response.data.head.flag === 0) {
                        this.ruleForm = response.data.content
                        console.log(this.ruleForm)
                    } else {
                        this.$message.error(response.data.head.desc)
                    }
                })
            },
            // 部分回传- 添加
            addBack (max, index) {
                console.log(max)
                // if (this.ruleForm.partReturnData[index].minTopUpAmount > this.ruleForm.partReturnData[index].maxTopUpAmount){
                //     this.$message.error('设置的金额区间不连续')
                // } else {
                this.ruleForm.partReturnData.push({
                    minTopUpAmount: index == this.ruleForm.partReturnData.length - 1 ? max : '',
                    maxTopUpAmount: null,
                    returnPercent: null,
                    returnLeach: null,
                    returnWay: 0
                })
                // }
            },
            // 部分回传- 删除
            delBack (index) {
                console.log(this.ruleForm.partReturnData.length)
                if (index == 0) {
                    this.ruleForm.partReturnData[index+1].minTopUpAmount = 1
                } else if (index < this.ruleForm.partReturnData.length - 1) {
                    console.log(this.ruleForm.partReturnData[index+1].minTopUpAmount)
                    this.ruleForm.partReturnData[index+1].minTopUpAmount = this.ruleForm.partReturnData[index-1].maxTopUpAmount
                }
                this.ruleForm.partReturnData.splice(index,1)
            },
            // 部分回传- 值改变
            inputMax (index, val) {
                console.log(val)
                if (index < this.ruleForm.partReturnData.length - 1){
                    this.ruleForm.partReturnData[index + 1].minTopUpAmount = val
                }
            },
            // 部分回传- 值改变
            changeMax (index, val) {
                console.log(index, this.ruleForm.partReturnData.length)
                if (index < this.ruleForm.partReturnData.length - 1){
                    this.ruleForm.partReturnData[index + 1].minTopUpAmount = val
                }
                if (this.ruleForm.partReturnData[index].minTopUpAmount > this.ruleForm.partReturnData[index].maxTopUpAmount ) {
                    this.$message.error('设置的金额区间不连续')
                }
            },
            // 保存审核信息
            saveData () {
                if (this.ruleForm.returnCaliber == 0) {
                    this.ruleForm.partReturnData = [
                        {
                            minTopUpAmount: 0,
                            maxTopUpAmount: null,
                            returnWay: 0,
                            returnLeach: null,
                            returnPercent: null
                        }
                    ]
                    this.ruleForm.returnProtection = null
                }
                add(this.ruleForm).then((response) => {
                    console.log(response)
                    if (response.data.head.flag === 0) {
                        // console.log(response.data.content)
                        this.$message({
                            message: '提交成功',
                            type: 'success'
                        });
                        this.dialogFormVisible = false
                        this.getTableData()
                    } else {
                        this.$message.error(response.data.head.desc)
                    }
                })
            },
            // 弹框确定
            editDialogSureBtn () {
                this.$refs['ruleForm'].validate((valid) => {
                    if (valid) {
                        this.saveData()
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            // 获取表格列表
            getTableData () {
                let json2 = {
                    pageNo: this.currentPage,
                    pageSize: this.tableData.pageSize
                };
                let json1 = this.formInline;
                let paramJson = { ...json1, ...json2 };
                list(paramJson).then((response) => {
                    console.log(response)
                    if (response.data.head.flag === 0) {
                        this.tableData = response.data.content
                    } else {
                        this.$message.error(response.data.head.desc)
                    }
                })
            },
            // 获取小程序列表
            // getAppList () {
            //     this.axios({
            //         method: 'get',
            //         url: '/v1/ys/sinamanage/getWeiBoAppNameList',
            //         params: {
            //         }
            //     }).then((response) => {
            //         console.log(response)
            //         // this.optionsApp = response.data
            //         if (response.data.head.flag === 0) {
            //             this.appOptions = response.data.content
            //             this.formInline.CDId = response.data.content[0].CDId
            //             this.appName = response.data.content[0].appName
            //             this.getTableData();
            //         } else {
            //             this.$message.error(response.data.head.desc)
            //         }
            //     })
            // }
        }
    }
</script>